import "./index.css"
import "./mobile.css";
import DialogBox from "../dialog-box"
import ProgramModule from "../program-module"
import { useState,useEffect } from "react"
import { startingModules } from "../../random-stored-js/starting-modules";
import DevDiary from "../dev-diary";
import Collection from "../collection";
import SettingsBlock from "../settings";
import Blog from "../blog";
import Minesweeper from "../minesweeper";
import GetInput from "../input";

function ProgramList(props){
  const [isDragging, setIsDragging] = useState({status:false,index:null});
  const [originalMousePosition, setOriginalMousePosition] = useState({ x: 0, y: 0 });
  const [bodySizing, setbodySizing] = useState({ height: 0, width: 0 });
  useEffect(() => {
    const docWidth = document.body.clientWidth;
    const docHeight = document.body.clientHeight;
    setbodySizing({ height:docHeight, width:docWidth });
  }, []);

  const onMouseDown = async(e) => {
    let targetElement = e.target;
    if (targetElement.className.search("close-button") !== -1) return;
    let boxindex = Number(targetElement.getAttribute("data-boxindex"));
    // Convert the current module's left and top from percentage to pixels for calculation
    const moduleLeftInPixels = modules[boxindex].left * bodySizing.width;
    const moduleTopInPixels = modules[boxindex].top * bodySizing.height;
    setOriginalMousePosition({
      x: e.clientX - moduleLeftInPixels,
      y: e.clientY - moduleTopInPixels,
    });
    if (targetElement.className.search("draggable-box") !== -1) {
      const highestZIndex = modules.reduce((max, module) => Math.max(max, module.zIndex || 0), 0);
      let newModuleArr = [...modules];
      newModuleArr[boxindex].zIndex = highestZIndex + 1;
      SetModules(newModuleArr);
    }
    await setIsDragging({status: true, index: boxindex});
  };
  const onMouseMove = (e) => {
    if (isDragging.status === false) return;
    let newLeft = (e.clientX - originalMousePosition.x) / bodySizing.width;
    let newTop = (e.clientY - originalMousePosition.y) / bodySizing.height;
    let boxindex = isDragging.index;
    if(boxindex === null) return; // Early return if boxindex is null
    
    SetModules(modules => modules.map((item, index) => {
      if (index === boxindex) {
        // Update left and top as percentages
        return {
          ...item,
          left: newLeft,
          top: newTop
        };
      }
      return item;
    }));
  };
  const onMouseUp = () => {
    setIsDragging({status:false,index:null});
  };
  const closeFunction = (number) => {
    SetModules(modules => modules.filter((_, index) => index !== number));
  };
  const handleProgramClick = (e) => {
    if(modules[e].expansion){
      openDocument(modules[e].expansion);
    }
  }
  const openDocument = (expansion) => {
    SetModules(modules => {
      const index = modules.findIndex(item => item.heading === expansion.heading); 
      let highestZIndex = modules.reduce((max, module) => Math.max(max, module.zIndex || 0), 0);
      if (index!==-1) {
        let updatedModules = [...modules];
        updatedModules[index] = {
          ...updatedModules[index],
          zIndex: highestZIndex + 1
        };        
        return updatedModules;
      } else {
        let docToAdd = expansion;
        docToAdd.zIndex = highestZIndex;
        const newBox = docToAdd;
        return [...modules, newBox];
      }
    });
  };
  function handleResize() {
    setbodySizing({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }
  //window.addEventListener('resize', handleResize);
  const [modules,SetModules] = useState(startingModules(handleProgramClick));

  return (
    <div id="program-list" style={{backgroundColor:props.color}}>
      {modules.map((module, index) => {
        let left = bodySizing.width * module.left;
        let top = bodySizing.height * module.top;
                          if (module.type === "input") {
                            return (
                              <GetInput
                                key={index}
                                indexNumber={index}
                                imageSource={module.headingImageSource}
                                left={left}
                                top={top}
                                heading={module.heading}
                                moveFunction={onMouseMove}
                                upFunction={onMouseUp}
                                closeFunction={closeFunction}
                                downFunction={onMouseDown}
                                zIndex={module.zIndex}
                              />
                            );
                          }
                  if (module.type === "minesweeper") {
                    return (
                      <Minesweeper
                        key={index}
                        indexNumber={index}
                        imageSource={module.headingImageSource}
                        left={left}
                        top={top}
                        heading={module.heading}
                        moveFunction={onMouseMove}
                        upFunction={onMouseUp}
                        closeFunction={closeFunction}
                        downFunction={onMouseDown}
                        zIndex={module.zIndex}
                      />
                    );
                  }
          if (module.type === "blog") {
            return (
              <Blog
                key={index}
                indexNumber={index}
                imageSource={module.headingImageSource}
                left={left}
                top={top}
                heading={module.heading}
                moveFunction={onMouseMove}
                upFunction={onMouseUp}
                content={module.content}
                closeFunction={closeFunction}
                downFunction={onMouseDown}
                zIndex={module.zIndex}
              />
            );
          }
                        if (module.type === "settings") {
                          return (
                            <SettingsBlock
                              key={index}
                              indexNumber={index}
                              imageSource={module.headingImageSource}
                              left={left}
                              top={top}
                              heading={module.heading}
                              changeColorFunction={props.changeColorFunction}
                              changeHeaderFunction={props.changeHeaderFunction}
                              seizureModeFunction={props.seizureModeFunction}
                              resetSettings={props.resetSettings}
                              previousStatePass={props.previousStatePass}
                              moveFunction={onMouseMove}
                              upFunction={onMouseUp}
                              closeFunction={closeFunction}
                              downFunction={onMouseDown}
                              zIndex={module.zIndex}
                            />
                          );
                        }
                if (module.type === "collection") {
                  return (
                    <Collection
                      key={index}
                      indexNumber={index}
                      imageSource={module.headingImageSource}
                      left={left}
                      bodySizing={bodySizing}
                      functionToAdd={openDocument}
                      top={top}
                      collection={module.collection}
                      heading={module.heading}
                      closeFunction={closeFunction}
                      moveFunction={onMouseMove}
                      upFunction={onMouseUp}
                      downFunction={onMouseDown}
                      zIndex={module.zIndex}
                    />
                  );
                }
        if (module.type === "diary") {
          return (
            <DevDiary
              key={index}
              indexNumber={index}
              imageSource={module.headingImageSource}
              left={left}
              top={top}
              randomHighlight={module.randomHighlight}
              heading={module.heading}
              text={module.bodyText}
              bodyButtonText={module.bodyButtonText}
              bodyImageSource={module.bodyImageSource}
              closeFunction={closeFunction}
              moveFunction={onMouseMove}
              upFunction={onMouseUp}
              downFunction={onMouseDown}
              zIndex={module.zIndex}
            />
          );
        }
        if (module.type === "program") {
          return (
            <ProgramModule
              key={index}
              indexNumber={index}
              functionToAdd={module.functionToAdd}
              left={left}
              top={top}
              name={module.name}
              imageSource={module.imageSource}
              moveFunction={onMouseMove}
              upFunction={onMouseUp}
              downFunction={onMouseDown}
              bodySizing={bodySizing}
            />
          );
        } else if (module.type === "dialog") {
          return (
            <DialogBox
              key={index}
              indexNumber={index}
              imageSource={module.headingImageSource}
              left={left}
              top={top}
              heading={module.heading}
              text={module.bodyText}
              bodyButtonText={module.bodyButtonText}
              bodyImageSource={module.bodyImageSource}
              closeFunction={closeFunction}
              moveFunction={onMouseMove}
              upFunction={onMouseUp}
              downFunction={onMouseDown}
              zIndex={module.zIndex}
            />
          );
        }
        return null; // In case of an unrecognized type
      })}
    </div>
  );
}


export default ProgramList